import { type Action, configureStore, type ThunkAction } from '@reduxjs/toolkit'
import { accountChargeRunApi } from '../api-services/asset-holdings/accountChargeRunApi'
import { activityStatementApi } from '../api-services/asset-holdings/activityStatementApi'
import { adminCellOwnerAgreementsApi } from '../api-services/asset-holdings/adminCellOwnerAgreementApi'
import { cellOwnerAgreementsApi } from '../api-services/asset-holdings/cellOwnerAgreementApi'
import { currencyExchangeApi } from '../api-services/financial/currencyExchangeApi'
import { journalReconApi } from '../api-services/financial/journalReconApi'
import { ledgerAccountApi } from '../api-services/financial/ledgerAccountApi'
import { distributionInstructionApi } from '../api-services/asset-holdings/distributionInstructionApi'
import { projectApi } from '../api-services/assets/projectApi'
import { assetHolderApi } from '../api-services/asset-holdings/assetHolderApi'
import { solarApi } from '../api-services/solar/solarApi'
import { adhocDistributionApi } from '../api-services/asset-holdings/adhocDistributionApi'
import { paymentsApi } from '../api-services/payments/paymentsApi'
import { kycArchiveApi } from '../api-services/kyc-archive/kycArchiveApi'

import editSolarProjectReducer from '../views-2/pages/solar-projects/editSolarProjectSlice'
import editAssetHolderReducer from '../views-2/pages/customer-operations/editAssetHolderSlice'
import kycArchiveReducer from '../views-2/pages/kyc-archive/kycArchiveSlice'
import uiWidgetsReducer from '../views-2/components/ui-widgets/uiWidgetsSlice'
import editSolarPlantReducer from '../views-2/pages/solar-engineering/solar-plants/editSolarPlantSlice'
import editDistributionInstructionReducer
  from '../views-2/pages/finance-area/weekly-distributions/editDistributionInstructionsSlice'
import { authenticationApi } from '../api-services/user/authenticationApi'
import disbursementsSliceReducer from '../views-2/pages/finance-area/disbursements/disbursementsSlice'
import exchangeInstructionsSliceReducer from '../views-2/pages/finance-area/currency-exchange-instructions/exchangeInstructionsSlice'

import editPortfoliosSliceReducer from '../views-2/pages/finance-area/settlements/editPortfoliosSlice'
import { portfolioSettlementsApi } from '../api-services/asset-holdings/portfolioSettlementsApi'

export const store = configureStore({
  reducer: {
    // APIs
    [cellOwnerAgreementsApi.reducerPath]: cellOwnerAgreementsApi.reducer,
    [adminCellOwnerAgreementsApi.reducerPath]: adminCellOwnerAgreementsApi.reducer,
    [activityStatementApi.reducerPath]: activityStatementApi.reducer,
    [ledgerAccountApi.reducerPath]: ledgerAccountApi.reducer,
    [distributionInstructionApi.reducerPath]: distributionInstructionApi.reducer,
    [adhocDistributionApi.reducerPath]: adhocDistributionApi.reducer,
    [projectApi.reducerPath]: projectApi.reducer,
    [assetHolderApi.reducerPath]: assetHolderApi.reducer,
    [currencyExchangeApi.reducerPath]: currencyExchangeApi.reducer,
    [solarApi.reducerPath]: solarApi.reducer,
    [authenticationApi.reducerPath]: authenticationApi.reducer,
    [paymentsApi.reducerPath]: paymentsApi.reducer,
    [portfolioSettlementsApi.reducerPath]: portfolioSettlementsApi.reducer,
    [journalReconApi.reducerPath]: journalReconApi.reducer,
    [accountChargeRunApi.reducerPath]: accountChargeRunApi.reducer,
    [kycArchiveApi.reducerPath]: kycArchiveApi.reducer,

    // Feature slices
    uiWidgets: uiWidgetsReducer,
    editSolarProject: editSolarProjectReducer,
    editAssetHolder: editAssetHolderReducer,
    kycArchive: kycArchiveReducer,
    editSolarPlant: editSolarPlantReducer,
    editDistributionInstruction: editDistributionInstructionReducer,
    portfoliosSlice: editPortfoliosSliceReducer,
    disbursementsSlice: disbursementsSliceReducer,
    exchangeInstructionsSlice: exchangeInstructionsSliceReducer
  },

  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(
    cellOwnerAgreementsApi.middleware,
    adminCellOwnerAgreementsApi.middleware,
    activityStatementApi.middleware,
    ledgerAccountApi.middleware,
    distributionInstructionApi.middleware,
    adhocDistributionApi.middleware,
    projectApi.middleware,
    assetHolderApi.middleware,
    currencyExchangeApi.middleware,
    solarApi.middleware,
    authenticationApi.middleware,
    solarApi.middleware,
    currencyExchangeApi.middleware,
    paymentsApi.middleware,
    portfolioSettlementsApi.middleware,
    journalReconApi.middleware,
    accountChargeRunApi.middleware,
    kycArchiveApi.middleware
  )
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
